import {debounce} from 'lodash'

export const breakpoint = {}

breakpoint.refreshValue = function () {
    this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '')
}

breakpoint.getValue = function () {
    this.refreshValue()
    return breakpoint.value
}

export function checkInCalcFooterOffset() {
    var $footer = $('footer'),
        $inCalcFooter = $('#in-calc-footer'),
        $totalCost = $('#total-cost'),
        $footerInCalcNav = $('.in-calc-nav'),
        windowHeight = window.innerHeight ? window.innerHeight : $(window).height()


    if(breakpoint.value == 'small') {
        if($(document).scrollTop() + windowHeight >= $footerInCalcNav.offset().top) {
            $totalCost.css('position', 'absolute').css('bottom', $('.in-calc-nav').outerHeight())
        } else {
            $totalCost.css('position', 'fixed').css('bottom', -1)
        }
    }

    if(breakpoint.value == 'medium' || breakpoint.value == 'large') {
        if($(document).scrollTop() + windowHeight >= $footer.offset().top) {
            $inCalcFooter.css('position', 'absolute').css('bottom', $footer.outerHeight())
        } else {
            $inCalcFooter.css('position', 'fixed').css('bottom', -1)
        }
    }
}

export const calculationChangedCallOut = debounce((function () {
    bus.$emit('calculation-changed')
}), 1000)

export function scrollToTop() {
    $("html, body").animate({
        scrollTop: 0
    }, 600)

    return false
}

export function redirect(to, newWindow = false) {
    if(!newWindow) {
        window.location = to
    } else {
        window.open(to)
    }
}

export function getScrollbarWidth() {
    var outer = document.createElement("div")
    outer.style.visibility = "hidden"
    outer.style.width = "100px"
    document.body.appendChild(outer)

    var widthNoScroll = outer.offsetWidth
    // force scrollbars
    outer.style.overflow = "scroll"

    // add innerdiv
    var inner = document.createElement("div")
    inner.style.width = "100%"
    outer.appendChild(inner)

    var widthWithScroll = inner.offsetWidth

    // remove divs
    outer.parentNode.removeChild(outer)

    return widthNoScroll - widthWithScroll
}

export function getScrollbarWidth2() {
    // Create the measurement node
    var scrollDiv = document.createElement("div")
    scrollDiv.className = "scrollbar-measure"
    document.body.appendChild(scrollDiv)

    // Get the scrollbar width
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    //console.warn(scrollbarWidth) // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv)

    return scrollbarWidth
}

// export function modalClose() {
//     $(".modal, .ec-modal").removeClass(['active', 'is-active'])
//     $('body').removeClass('has-modal')
//     $(document).trigger('modals-was-closed')
// }

export function modalClose() {
    $(".modal, .ec-modal").removeClass(['active', 'is-active'])
    $('body').removeClass('has-modal')
    $(document).trigger('modals-was-closed')
}

export function numberFormater(value, decimals = 0, decimalsFixed = false) {
    if(window.Intl && typeof window.Intl === "object") {
        let numberFormat = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: (decimalsFixed) ? decimals : 0,
            maximumFractionDigits: decimals
        })

        return numberFormat.format(value)
    }

    return value
}

export function placeholderFormater(el, decimals = 0) {
    let number = $(el).text()
    let decimalsFixed = false

    if(isNaN(number)) {
        return
    }

    // if($(el).attr('data-modifires-raw')) {
    //     return
    // }

    if($(el).attr('data-modifires-decimals')) {
        decimals = $(el).attr('data-modifires-decimals')
        
        if(decimals.endsWith('!')) {
            decimalsFixed = true
            decimals = decimals.slice(0, -1)
        }
    }
    
    number = numberFormater(number, decimals, decimalsFixed)
    
    // if($(el).attr('data-modifires-currency')) {
    //     number = number.concat(" EUR")
    // }

    $(el).text(number)
}

//deprecated! use NumberFormater!
export function formateCurrency(value, symbol = true) {
    let pattern = '#,##0 !'
    if(value % 1 !== 0) {
        pattern = '#,##0.00 !'
    }

    return CurrencyFormatter.format(value, {
        currency: 'EUR',
        symbol: (symbol) ? 'EUR':'',
        pattern: pattern
    })
}

//remove!

export const VueMixin = {
    methods: {
        currencyFormatter(value, symbol = true) {
            return formateCurrency(value, symbol)
        }
    }
}

export function stripTags(dirtyString) {  
    let div = document.createElement("div");
    div.innerHTML = dirtyString;
    return div.innerText;
}